import { render, staticRenderFns } from "./PostNotFound.vue?vue&type=template&id=c8ef3440&scoped=true"
import script from "./PostNotFound.vue?vue&type=script&lang=js"
export * from "./PostNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ef3440",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8ef3440')) {
      api.createRecord('c8ef3440', component.options)
    } else {
      api.reload('c8ef3440', component.options)
    }
    module.hot.accept("./PostNotFound.vue?vue&type=template&id=c8ef3440&scoped=true", function () {
      api.rerender('c8ef3440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/posts/components/feed/PostNotFound.vue"
export default component.exports